module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_9005.c2d4f2f4.png";